<template>
  <div class="pointer" :style="{bottom: bottom + 'px'}">
    <div
      class="pointer-content"
      :class="{ circle: type == 1, strip: type == 2}"
      :style="{ textAlign: align, marginLeft: margin + 'px', marginRight: margin + 'px'}"
      v-if="type < 3"
    >
      <span
        v-for="(_item, _index) in data"
        :key="_index"
        class="pointer-item"
        :class="{'active': _index === index}"
        :style="{'background-color': _index === index ? color : '#ebedf0' }"
      ></span>
    </div>

    <div
      class="pointer-text"
      v-if="type == 3"
      :style="{ textAlign: align, marginLeft: margin + 'px', marginRight: margin + 'px' }"
    >
      <span class="is-pointer-text">{{ index + 1 }}/{{ data.length }}</span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    number: {
      type: [String, Number, Boolean],
      default: "",
    },
    margin: {
      type: [Number, String],
      default: 10,
    },
    bottom: { // 距下边距
      type: [Number, String],
      default: 14,
    },
    total: {
      type: [Number, String],
      default: 2,
    },
    index: {
      type: [Number, String],
      default: 0,
    },
    type: {
      type: [String, Number, Boolean],
      default: 1,
    },
    align: {
      type: [String, Number, Boolean],
      default: "left",
    },
    color: {
      type: [String, Number, Boolean],
      default: "#f44",
    },
    data: {
      type: [Array, Object]
    }
  }
}
</script>

<style lang="scss" scoped>
.pointer {
  position: absolute;
  bottom: 14px;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  z-index: 99;
  width: 100%;

  .circle .pointer-item {
    display: inline-block;
    width: 6px;
    height: 6px;
    background-color: #ebedf0;
    border-radius: 100%;
    opacity: 0.3;
  }

  .strip .pointer-item {
    display: inline-block;
    width: 12px;
    height: 2px;
    background-color: #c5c5c5;
  }

  .pointer-item  {
    margin-left: 6px;
  }

  .pointer-content {
    width: 100%;
    box-sizing: border-box;
    text-align: right;

    .active {
      background-color: #f44;
      opacity: 1;
    }
  }

  .pointer-text {
    width: 100%;
    text-align: center;

    .is-pointer-text {
      display: inline-block;
      min-width: 18px;
      height: 18px;
      padding: 0 5px;
      color: #fff;
      font-size: 12px;
      line-height: 18px;
      background: #000;
      border-radius: 8px;
      opacity: 0.3;
    }
  }
}
</style>